export default {
  results: [],
  columns: [],
  headerColumns: [],
  parameters: {},
  selectedShares: [],
  isSelectAllChecked: false
};
